
import Vue from 'vue'
import { DEFAULT_DOMAIN } from '@/constants/domain'

const CHECKBOX_ID = 'consent-tnc-checkbox'

export default Vue.extend({
	name: 'ConsentAgreement',
	props: {
		value: {
			type: Boolean,
			required: true
		}
	},
	computed: {
		checkboxId(): string {
			return CHECKBOX_ID
		},
		opDomain(): string {
			return process.env.VUE_APP_OP_DOMAIN || DEFAULT_DOMAIN
		},
		tncUrl(): string {
			return this.$i18n.locale === 'en'
				? `https://www.${this.opDomain}/en/terms-conditions`
				: `https://www.${this.opDomain}/syarat-dan-ketentuan`
		},
		privacyPolicyUrl(): string {
			return this.$i18n.locale === 'en'
				? `https://www.${this.opDomain}/en/privacy-policy`
				: `https://www.${this.opDomain}/kebijakan-privasi`
		}
	},
	methods: {
		onCheckboxChange(event: Event) {
			const target = event.target as HTMLInputElement | null
			this.$emit('input', target?.checked ?? false)
		}
	}
})
